import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Breakpoint, Color, FontWeight, ShippingBoxTheme } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { ContainerProps } from './shippingBox.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  max-width: 740px;
  padding: 18px 16px;
  ${({ $boxTheme }: ContainerProps): FlattenSimpleInterpolation => 
    $boxTheme === ShippingBoxTheme.Light 
      ? css`
        color: ${Color.Black};
        border: 1px solid ${Color.Gray300};
      ` 
      : css`
        background-color: ${Color.Gray200};
        color: ${Color.Gray500};
      `
}
  cursor: pointer;
  border: ${({ $isActive }: ContainerProps): string | false => $isActive && `1px solid ${Color.Error500}`};

  @media ${Breakpoint.Mobile} {
    max-width: 100%;
  }
`;

export const ShippingBoxContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
`;

export const AddressContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
`;

export const SingleAddressContainer: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 4px;
  overflow-wrap: anywhere;
  
  &:last-child {
    margin: 0;
  }
`;

export const ButtonsContainer: StyledComponent<'div'> = styled.div`
  padding-left: 12px;
  flex-shrink: 0;
`;

export const StyledButton: StyledComponent<'button'> = styled.button`
  margin-right: 24px;
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  line-height: 18px;
  color: ${Color.Gray500};
  text-decoration: underline;

  &:last-child {
    margin: 0;
  }
`;

export const Title: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 10px;
`;
